import Portal = require("portal-gis");
import _ = require("underscore");
import Utils = require("../utils");
import geo = require("../utils/geo");

function renderFeature(feature: Rhythm.GIS.FeatureQueryResultFeature, args: {
    symbol: Portal.MonikerSymbologyElement
}) {
    let data = geo.getFeatureData(feature);
    let html = "";

    // honor the symbology label
    if (args && args.symbol) {
        let substitute = _.template(args.symbol.Label)(feature.attributes);
        html += `<li><label class='feature-title'>${substitute}</label></li>`;
    }

    html += render(data, true);
    return html;
}

function render(data, recursive = true, history = []) {
    let keys = _.keys(data).filter(k => typeof data[k] !== 'function');

    let html = keys.map(k => {
        let value = data[k];
        if (recursive) {
            if (typeof value === "object") {
                if (-1 == history.indexOf(value)) {
                    history.push(value);
                    value = render(value, true, history);
                    if (!value) return "";
                    return `<li><label class="expando closed">${k}</label><ul>${value}</ul></li>`;
                } else {
                    console.log("circular reference detected");
                }
            }
        }
        if (!value) return "";
        return `<li><label class='field-name' title='${k}'>${k}</label><label class='field-value' title='${value}'>${value}</label></li>`;
    }).join("");

    return html;

}


export = renderFeature;